import { ILayoutElement } from "@faire/web-api/indigofair/data/ILayoutElement";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";

export const layoutElementDataMap = (
  layoutElement: ILayoutElement,
  propertyName: string
) => {
  return (
    layoutElement.layout_element_data
      // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
      .map((layoutElementData) => layoutElementData[propertyName])
      .filter(isNotUndefined)
  );
};
